import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import { homeFor, readableRoles } from "./errorPageHelpers";

const ForbiddenPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const signedIn = useSelector((state) => state.auth.signedIn);
  const roles = useSelector((state) => state.auth.user?.roles);
  const email = useSelector((state) => state.auth.user?.email || "");
  const home = homeFor(roles);
  const canGoBack = location.key !== "default";

  // Naming the account is the fastest way for someone to spot that they are
  // signed in as the wrong one, which is the usual cause.
  const details = signedIn
    ? [
        ...(email ? [{ label: "Signed in as", value: email }] : []),
        { label: "Your access", value: readableRoles(roles) },
      ]
    : [];

  const actions = signedIn
    ? [
        { label: `Go to ${home.label}`, onClick: () => navigate(home.path) },
        ...(canGoBack ? [{ label: "Back", variant: "ghost", onClick: () => navigate(-1) }] : []),
      ]
    : [{ label: "Sign in", onClick: () => navigate("/user/login") }];

  return (
    <ErrorPage
      code="403"
      eyebrow="Access denied"
      title="You do not have access to this page"
      message={
        signedIn
          ? "This page exists, but it is not open to your role. If you believe you should have access, ask your subscription administrator or the ISAFE team to check your permissions."
          : "This page is only available once you are signed in with an account that has access to it."
      }
      actions={actions}
      details={details}
    />
  );
};

export default ForbiddenPage;
